import IconButton from '@mui/material/IconButton';
import { useGlobalCore } from '../../core/modules/global';
import useThemeMediaQuery from '../../core/hooks/useThemeMediaQuery';
import MenuIcon from '@mui/icons-material/Menu';

interface Props {
  className: string;
}

const NavbarToggleButton = (props: Props) => {
  const { toggleMobileNarvar, toggleNarvar } = useGlobalCore();
  const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down('lg'));

  return (
    <IconButton
      className={props.className}
      color="inherit"
      size="small"
      onClick={() => {
        if (isMobile) {
          toggleMobileNarvar();
        } else {
          toggleNarvar();
        }
      }}
    >
      <MenuIcon />
    </IconButton>
  );
};

export default NavbarToggleButton;
